import React, { useState, useEffect, ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import ListView from "~components/styled/listView/ListView";
import filterItems from "~libs/filterItems";
import { fetchCodigosPostales } from "./actions";
import SearcherList from "~styled/searcherList/SearcherList";

const useStyles = makeStyles(() => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "space-around",
  },
}));

interface CodigoPostalState {
  codigoPostalSelectorReducer: {
    codigosPostales: { label: string; value: string | null }[];
    isLoading: boolean;
  };
}

interface CodigoPostalSelectorProps {
  label: string;
  onChange?: (event: { target: { value: string | null } }) => void;
  provinciaId: string | null;
  localidad?: string;
}

const useReduxSelector = () => {
  return useSelector((state: CodigoPostalState) => {
    const codigoPostalSelectorReducer = state.codigoPostalSelectorReducer;

    return {
      codigosPostales: codigoPostalSelectorReducer.codigosPostales,
      isLoading: codigoPostalSelectorReducer.isLoading,
    };
  });
};

const CodigoPostalSelector: React.FC<CodigoPostalSelectorProps> = ({
  label,
  onChange,
  provinciaId,
  localidad = "",
}) => {
  const [filter, setFilter] = useState<string>("");
  const dispatch = useDispatch();
  const { codigosPostales, isLoading } = useReduxSelector();

  useEffect(() => {
    if (provinciaId) {
      dispatch(fetchCodigosPostales(provinciaId, localidad));
    }
  }, []);

  const handleItemSelected = (item: {
    label: string;
    value: string | null;
  }) => {
    setFilter("");
    if (onChange) {
      onChange({ target: { value: item.value } });
    }
  };

  const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  const classes = useStyles();

  return (
    <div className={classes.searcher}>
      <SearcherList
        onClear={() => setFilter("")}
        filter={filter}
        onChange={handleFilterChange}
        placeholder={label}
        borderBottomRounded={false}
      />
      <ListView
        isLoading={isLoading}
        onItemSelected={handleItemSelected}
        list={
          filter === "" ? codigosPostales : filterItems(codigosPostales, filter)
        }
      />
    </div>
  );
};

export default CodigoPostalSelector;
